import { createContext, type ReactNode } from "react";

/** App composition supplies personal notifications without shared chrome importing a feature. */
export const HeaderNotificationContext = createContext<ReactNode>(null);
